import { layoutLines } from "./LayoutLines";
import AddSignatureModal from "../components/AddSignatureModal";

const stateColors = {
  waiting: "slate",
  done: "lime",
};

function readOnlyDoneWaiting(rec) {
  return rec.state === "done" || rec.state === "waiting";
}
function readOnlyEmployee(rec) {
  return rec?.number;
}

function recIdNumber(rec, name, value) {
  let idNumber;

  if (rec?.["employee."]?.["party."]?.id_number) {
    idNumber = rec?.["employee."]?.["party."]?.id_number;
  } else {
    idNumber = rec.employee?.party?.id_number;
  }
  return idNumber;
}

function accDelete(rec) {
  let res = rec.state == "done" ? false : true;
  return res;
}

function nameCustom(name, rec) {
  let _name = rec.state == "waiting" ? "Asignar firma" : "Ver firma";
  return _name;
}

function layoutStaffSupply() {
  let ctxView = {
    model: "staff_supply.request",
    hiddenTitle: true,
    tags: {
      state: stateColors,
    },
    table_action: ["edit"],
    form_action: ["edit", "add", "delete"],
    activeSearch: true,
    domain: [["state", "!=", "done"]],
    limit: 10,
    pagination: [],
    access: {
      delete: accDelete,
      edit: () => true,
    },
    fields: {
      number: {
        type: "char",
        readOnly: true,
        searchable: true,
      },
      employee: {
        type: "many2one",
        model: "company.employee",
        searchable: true,
        attrs: [
          "position.name",
          "party.id_number",
          "operation_center.name",
          "department.name",
        ],
        readOnly: readOnlyEmployee,
        filter: true,
      },
      "employee.party.id_number": {
        type: "char",
        function: recIdNumber,
        searchable: true,
        readOnly: true,
      },
      position: {
        type: "many2one",
        model: "staff.position",
        readOnly: true,
        filter: true,
      },
      warehouse: {
        type: "many2one",
        model: "stock.location",
        recSearch: () => ["rec_name", "ilike", `%ZA %`],
        // filter: true,
        required: true,
        readOnly: readOnlyDoneWaiting,
      },
      reason: {
        type: "selection",
        options: [
          { id: "role_change", name: "Role Change" },
          { id: "onboarding", name: "Onboarding" },
          { id: "loss", name: "Loss" },
          { id: "damage", name: "Damage" },
          { id: "other", name: "Other" },
        ],
        filter: true,
        translate: true,
        required: true,
        readOnly: readOnlyDoneWaiting,
      },
      request_date: {
        type: "date",
        readOnly: true,
        default: new Date(),
        filter: true,
      },
      effective_date: {
        type: "date",
        readOnly: true,
        default: new Date(),
      },
      observation: {
        type: "text",
      },
      state: {
        type: "char",
        readOnly: true,
        tags: stateColors,
        translate: true,
      },
      lines: {
        type: "one2many",
        model: "staff_supply.request.line",
        customModel: "product.product",
        filterFieldSearch: "name",
        layout: layoutLines(),
        readOnly: readOnlyDoneWaiting,
        filter: true,
        filterField: "product",
      },

      add_signature: {
        type: "button_custom_modal",
        // readOnly: disableButtonSignal,
        color: "black",
        customName: nameCustom,
        Component: AddSignatureModal,
      },
    },
    form: [
      {
        name: "block1",
        type: "grid",
        elements: [
          { name: "employee" },
          { name: "reason" },
          { name: "warehouse" },
        ],
        colSpan: "col-span-2",
        col: "grid-cols-3",
      },
      {
        name: "block2",
        type: "grid",
        elements: [
          { name: "employee.party.id_number" },
          { name: "position" },
          // { name: "employee.department.name" },
        ],
        colSpan: "col-span-3",
        col: "grid-cols-2",
      },
      {
        name: "block3",
        type: "grid",
        elements: [
          { name: "request_date" },
          { name: "effective_date" },
          { name: "state" },
        ],
        colSpan: "col-span-3",
        col: "grid-cols-2",
      },
      {
        name: "tables",
        type: "grid",
        elements: [{ name: "lines" }],
        colSpan: "col-span-3",
      },
      {
        name: "observation",
        type: "grid",
        elements: [{ name: "observation" }],
        colSpan: "col-span-3",
      },
    ],
    list: [
      { name: "number" },
      { name: "request_date" },
      { name: "employee" },
      { name: "employee.party.id_number" },
      { name: "position" },
      { name: "warehouse" },
      { name: "reason" },
      { name: "state" },
      { name: "add_signature" },
    ],
  };

  return ctxView;
}

export { layoutStaffSupply };

// eliminar esto
